module.exports = __webpack_public_path__ + "down-arrow.png?19c2006c0545f987f86abd428f4653dd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down-arrow.png
// module id = 18
// module chunks = 0